import http from '@/utils/request';
//我的订单
export function getUserOrders(query) {
  return http.request({
    url: '/mro/portalOrder/getUserOrders',
    method: 'get',
    params: query,
  });
}
//获取订单详情
export function getUserOrderDetail(id, query) {
  return http.request({
    url: `/mro/order/getDetails/${id}`,
    method: 'get',
    params: query,
  });
}
//前台获取订单详情
export function getUserDetails(id, query) {
  return http.request({
    url: `mro/portalOrder/getUserDetails/${id}`,
    method: 'get',
    params: query,
  });
}
//商家中心获取详情
export function getShopOrderDetail(id, query) {
  return http.request({
    url: `/mro/order/getPurchaseDetails/${id}`,
    method: 'get',
    params: query,
  });
}

// 立即购买生成确认单
export function generateConfirmOrder(data) {
  return http.request({
    url: '/mro/portalOrder/generateConfirmOrder',
    method: 'post',
    data,
  });
}

// 批量下单生成确认单
export function generateBatchConfirmOrder(data) {
  return http.request({
    url: '/mro/batchOrder/generateBatchOrder',
    method: 'post',
    data,
  });
}

// 批量下单下单
export function createBatchOrder(data) {
  return http.request({
    url: '/mro/batchOrder/batchCreateOrder',
    method: 'post',
    data,
  });
}

// 立即购买下单
export function createInstantOrder(data) {
  return http.request({
    url: '/mro/portalOrder/createInstantOrder',
    method: 'post',
    data,
  });
}

//  获取供应商订单
export function getSupplierOrders(query) {
  return http.request({
    url: '/mro/order/getSupplierOrders',
    method: 'get',
    params: query,
  });
}

/** 子项发货 */

export function orderItemDelivery(data) {
  return http.request({
    url: '/mro/orderItem/delivery',
    method: 'put',
    data,
  });
}

/** 大单发货 */
export function orderDelivery(data) {
  return http.request({
    url: '/mro/order/delivery',
    method: 'put',
    data,
  });
}

// 前台子项确认收货
export function portalOrderconfirmOrderItem(orderItemId, data) {
  return http.request({
    url: `/mro/portalOrder/confirmOrderItem/${orderItemId}`,
    method: 'put',
    data,
  });
}

// 前台整单确认收货
export function confirmOrder(orderId, data) {
  return http.request({
    url: `/mro/portalOrder/confirmOrder/${orderId}`,
    method: 'put',
    data,
  });
}

// 购物车生成确认单
export function cartGenerateConfirmOrder(data) {
  return http.request({
    url: '/mro/portalOrder/cartGenerateConfirmOrder',
    method: 'post',
    data,
  });
}

// 购物车下单
export function createOrderByCart(data) {
  return http.request({
    url: '/mro/portalOrder/createOrderByCart',
    method: 'post',
    data,
  });
}

//企业控制台订单

export function getBuyersOrders(query) {
  return http.request({
    url: '/mro/order/getBuyersOrders',
    method: 'get',
    params: query,
  });
}
// http://10.9.15.82:12300/mro/order/getBuyersOrders?pageSize=10&pageNum=1

/** 商家中心 退换货订单列表 */

export function getAfterOrders(query) {
  return http.request({
    url: '/mro/apply/list',
    method: 'get',
    params: query,
  });
}

export function getAfterOrderDetail(id) {
  return http.request({
    url: '/mro/apply/' + id,
    method: 'get',
  });
}

export function afterOrderApprove(query) {
  return http.request({
    url: '/mro/apply/ok/' + query.id,
    method: 'get',
  });
}

export function afterOrderApproveRefuse(data) {
  return http.request({
    url: '/mro/apply/no',
    method: 'post',
    data,
  });
}

export function afterOrderDelivery(data) {
  return http.request({
    url: '/mro/apply/ship/' + data.id,
    method: 'post',
    data,
  });
}

/** 完成订单 */
export function finishReturnOrder(id) {
  return http.request({
    url: '/mro/apply/finish/' + id,
    method: 'get',
  });
}
//前台发货前修改地址
export function editAddress(data) {
  return http.request({
    url: '/mro/user/address/editAddress',
    method: 'put',
    data,
  });
}

//获取订单各项数量
export function getUserOrderCounts(query) {
  return http.request({
    url: '/mro/portalOrder/getUserOrderCounts',
    method: 'get',
    params: query,
  });
}

//取消订单
export function cancelOrder(id) {
  return http.request({
    url: '/mro/portalOrder/cancelOrder/' + id,
    method: 'put',
  });
}

//查询订单日志
export function getorderLog(id, query) {
  return http.request({
    url: `/mro/orderLog/${id}`,
    method: 'get',
    params: query,
  });
}

//上传支付凭证
export function uploadCertificate(data) {
  return http.request({
    url: '/mro/portalOrder/uploadCertificate',
    method: 'post',
    data,
  });
}

//购物车购买生成确认页计算运费价格
export function cartFreightAmount(data) {
  return http.request({
    url: '/mro/portalOrder/cartFreightAmount',
    method: 'post',
    data,
  });
}

//立即确认页计算运费价格
export function getFreightAmount(data) {
  return http.request({
    url: '/mro/portalOrder/getFreightAmount',
    method: 'post',
    data,
  });
}

// 询价单生成确认单
export function consultGenerateConfirmOrder(data) {
  return http.request({
    url: '/mro/portalOrder/consultGenerateConfirmOrder',
    method: 'post',
    data,
  });
}

// 询价单下单
export function createOrderByConsultOrders(data) {
  return http.request({
    url: '/mro/portalOrder/createOrderByConsultOrders',
    method: 'post',
    data,
  });
}

//寻源生成确认单
export function quotationGenerateConfirmOrder(data) {
  return http.request({
    url: '/mro/portalOrder/quotationGenerateConfirmOrder',
    method: 'post',
    data,
  });
}

// 寻源下单
export function createOrderByProductQuotationOrders(data) {
  return http.request({
    url: '/mro/portalOrder/createOrderByProductQuotationOrders',
    method: 'post',
    data,
  });
}

// 套餐生成确认单
export function packageGenerateConfirmOrder(data) {
  return http.request({
    url: '/mro/portalOrder/packageGenerateConfirmOrder',
    method: 'post',
    data,
  });
}

// 套餐生成订单 /portalOrder/creatOrderByPackage

export function creatOrderByPackage(data) {
  return http.request({
    url: '/mro/portalOrder/creatOrderByPackage',
    method: 'post',
    data,
  });
}

//获取订单数量
export function getOrderCount() {
  return http.request({
    url: '/mro/portalOrder/getUserTotalOpCounts',
    method: 'get',
  });
}
